const features = [
  {
    icon: 'ri-movie-2-line',
    title: '海量片库全覆盖',
    desc: '最新电影大全涵盖动作片在线、喜剧片免费看、科幻片高清播放及经典电影全集，10万+影片资源随心选，全类型片库每周持续扩充。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放不卡顿',
    desc: '采用智能CDN加速与多线节点分发技术，无论热门大片还是冷门佳片，均能实现秒加载、零缓冲的高清流畅观影体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全免费无广告',
    desc: '天天影院坚持纯免费观影模式，全程无弹窗广告、无恶意跳转、无隐藏收费，为影迷打造干净清爽的在线影院环境。',
  },
];

export default function FeatureSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          为什么选择天天影院
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          数以万计影迷的信赖之选，用心打造每一帧观影体验
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-8 hover:border-primary-500/30 transition-colors group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500/10 mb-5 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}